export const IMR_SUBJECT = 'social-studies';

export function imrQuizId(id) {
  return `imr_${id}`;
}

export function blankImageMapMcq() {
  return {
    question: '',
    options: ['', '', '', ''],
    correct: 0,
    explanation: '',
  };
}

function parseImageMapCorrect(raw) {
  if (typeof raw === 'number' && raw >= 0 && raw <= 3) return Math.round(raw);
  const text = String(raw ?? '').trim().toUpperCase();
  if (text.length === 1 && text >= 'A' && text <= 'D') return text.charCodeAt(0) - 65;
  const number = Number(text);
  if (number >= 0 && number <= 3) return number;
  if (number >= 1 && number <= 4) return number - 1;
  return 0;
}

export function importImageMapJson(raw) {
  let data = raw;
  if (typeof raw === 'string') {
    try {
      data = JSON.parse(raw);
    } catch {
      throw new Error('That file is not valid JSON.');
    }
  }
  const list = Array.isArray(data) ? data : data?.questions;
  if (!Array.isArray(list) || !list.length) throw new Error('JSON must contain a questions array.');
  const questions = list.map((item) => ({
    question: String(item?.question || item?.stem || '').trim(),
    options: [0, 1, 2, 3].map((index) => {
      const option = item?.options?.[index];
      if (option && typeof option === 'object') return String(option.text || '').trim();
      return String(option || '').trim();
    }),
    correct: parseImageMapCorrect(item?.correct),
    explanation: String(item?.explanation || '').trim(),
  })).filter((question) => question.question);
  if (!questions.length) throw new Error('No questions found in that JSON.');
  return questions;
}

export function sampleImageMapJsonText() {
  return `${JSON.stringify({
    questions: [
      {
        question: 'Which region on this map has the most electoral votes?',
        options: ['The Northeast', 'The South', 'The West', 'The Midwest'],
        correct: 'B',
        explanation: 'The South is marked for the largest share of electoral votes.',
      },
    ],
  }, null, 2)}\n`;
}

export function normalizeImageMapQuestions(questions = []) {
  return (questions || [])
    .map((q) => {
      const options = [0, 1, 2, 3].map((i) => String(q?.options?.[i] || '').trim());
      const correct = Math.max(0, Math.min(3, Number(q?.correct) || 0));
      return {
        question: String(q?.question || '').trim(),
        options,
        correct,
        explanation: String(q?.explanation || '').trim(),
      };
    })
    .filter((q) => q.question && q.options.every(Boolean));
}

/** Shape QuizModal expects, including optional per-option explanations. */
export function toQuizModalQuestions(questions = []) {
  return normalizeImageMapQuestions(questions).map((q) => ({
    question: q.question,
    options: q.options,
    correct: q.correct,
    explanations: q.options.map((_, i) =>
      i === q.correct && q.explanation ? q.explanation : ''
    ),
  }));
}

export function isSocialStudiesImrUnlocked(modules, daysByModule, completedLessons) {
  const mods = (modules || []).filter((m) => m.subject === IMR_SUBJECT);
  if (mods.length === 0) return true;
  return mods.every((mod) => {
    if (daysByModule[mod.id] === undefined) return false;
    const days = daysByModule[mod.id] || [];
    if (days.length === 0) return true;
    return days.every((d) => Boolean(completedLessons?.[d.id]));
  });
}

export function isImrItemLocked(items, index, passedMap, clearedMap, unlocked) {
  if (!unlocked) return true;
  if (index <= 0) return false;
  const prev = items[index - 1];
  if (!prev) return false;
  return !(passedMap[prev.id] || clearedMap[prev.id]);
}

export function firstPendingImageMapReading(items, passedMap, clearedMap) {
  return (items || []).find((item) => !(passedMap[item.id] || clearedMap[item.id])) || null;
}
